import Provider from './ProviderPresenter';
import { useSnackbar } from 'notistack';
import theme from './styles/theme';
import colorSet from './styles/colorSet';
import clsx from 'clsx';

export { useSnackbar, clsx, theme, colorSet };
export default Provider;
